import * as React from 'react'

class ListItem extends React.Component{
    constructor(props) {
        super(props);
        let {list_money,other_amount} = props.data.data;
        let getDataMoney = props.getDataMoney;
        this.state = {
            list_money : list_money,
            other_amount : other_amount,
            data_money : '',
            getDataMoney : getDataMoney,
        }
    this.getMoney = this.getMoney.bind(this)

    }
    getMoney = (event) => {
        let targetDom = event.target;
        let parent = targetDom.parentElement;
        let siblingParent = parent.nextSibling;
        siblingParent && siblingParent.classList.remove('active');
        let checkActive = parent.querySelector('.active');
        checkActive && checkActive.classList.remove('active');
        targetDom.classList.add('active');
        let convertMoney = targetDom.innerHTML.replace("S$", "");
        
        let index = targetDom.dataset.key;
        this.state.getDataMoney(convertMoney, index)
    } 
    
    getOtherMoney = (event) => {
        let targetOther = event.target; 
        let parentOther = targetOther.parentElement;
        let siblingNext = parentOther.nextSibling;
        let checkActive = parentOther.querySelector('.active');
        checkActive && checkActive.classList.remove('active');
        siblingNext && siblingNext.classList.add('active');
        targetOther.classList.add('active');

        let list_money = this.state.list_money;
        this.state.getDataMoney('', list_money.length);
        
    }
    render(props){
        let list_money = this.state.list_money;
        let {moneyState} = this.props;
        
        const list = list_money.map((value, index) => {
            let classActive = (index === moneyState) ? ' active' : '';
            return (
                    <button onClick={this.getMoney} data-key={index} key={index} className={'ecf-box-donate__items_item' + classActive}>
                    S${value.price_donate}
                    </button>
            );
        });

        let classOtherActive = (list_money.length === moneyState) ? ' active' : '';
        let {title} = this.state.other_amount
        return (
            <>
            <div className="row ecf-box-donate__items">
                {list}
                <button className={'ecf-box-donate__items_item' + classOtherActive} onClick={() => {this.getOtherMoney(event)}}>
                    {title}
                </button>
            </div>
            </>
            
        )
    }
}
export default ListItem;